/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  catalogEntryId: string;
  channelId: string;
}

export function storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete(http: HttpClient, rootUrl: string, params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.path('channelId', params.channelId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

storesStoreIdCatalogEntryOverridesCatalogEntryIdChannelIdDelete.PATH = '/stores/{storeId}/catalog-entry-overrides/{catalogEntryId}/{channelId}';
